<template>
  <div class="text-center">
    <div class="col-sm-12">
      <h2>{{ formatDate(event.date) }}</h2>
      <h5>
        <span class="glyphicon glyphicon-time"></span>Total time:
        {{ event.time }} hours.
      </h5>
      <h4 style="margin-top: 30px">
        <small
          ><button class="btn btn-success" v-on:click="navigate()">
            View All Events
          </button></small
        >
      </h4>
    </div>
  </div>
</template>

<script>
import { server, formatDate } from "../../utils/helper";
import axios from "axios";
import router from "../../router";
export default {
  data() {
    return {
      id: 0,
      event: {},
    };
  },
  created() {
    this.id = this.$route.params.id;
    this.getEvent();
  },
  methods: {
    formatDate,
    getEvent() {
      axios
        .get(`${server.baseUrl}/events/${this.id}`)
        .then((data) => (this.event = data.data));
    },
    navigate() {
      router.go(-1);
    },
  },
};
</script>
